import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '@/store';

type ChatSliceState = {
  chatList: { id: string; title: string; is_pinned?: boolean }[];
  sidebarOpen: boolean;
};

const initialState: ChatSliceState = {
  chatList: [],
  sidebarOpen: false,
};

const slice = createSlice({
  name: 'chats',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.sidebarOpen = !state.sidebarOpen;
    },
    closeSidebar(state) {
      state.sidebarOpen = false;
    },
    openSidebar(state) {
      state.sidebarOpen = true
    },
    setChatList(state, action) {
      state.chatList = action.payload;
    },
    resetChats(state) {
      state.chatList = [];
      state.sidebarOpen = false;
    }
  },
});

export const { toggleSidebar, closeSidebar, openSidebar, setChatList, resetChats } = slice.actions;
export default slice.reducer;

export const selectSidebarOpen = (s: RootState) => s.chats.sidebarOpen;
